/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import * as components from "../components/index.js";

export type QueryTrendsRequest = {
  agentId: string;
  body: components.QueryTrendsRequestBody;
};

/** @internal */
export type QueryTrendsRequest$Outbound = {
  agent_id: string;
  body: components.QueryTrendsRequestBody$Outbound;
};

/** @internal */
export const QueryTrendsRequest$outboundSchema: z.ZodType<
  QueryTrendsRequest$Outbound,
  z.ZodTypeDef,
  QueryTrendsRequest
> = z.object({
  agentId: z.string(),
  body: components.QueryTrendsRequestBody$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function queryTrendsRequestToJSON(
  queryTrendsRequest: QueryTrendsRequest,
): string {
  return JSON.stringify(
    QueryTrendsRequest$outboundSchema.parse(queryTrendsRequest),
  );
}
